import { render, staticRenderFns } from "./ReviewShell.vue?vue&type=template&id=db2bccc2&scoped=true&"
import script from "./ReviewShell.vue?vue&type=script&lang=js&"
export * from "./ReviewShell.vue?vue&type=script&lang=js&"
import style0 from "./ReviewShell.vue?vue&type=style&index=0&id=db2bccc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2bccc2",
  null
  
)

export default component.exports